/**
 * This file provides a GLOBAL CONTEXT to be used across the application.
 * It exports a context provider that wraps the entire app and provides
 * a context to be used by any component in the app.
 * The context is used to store and manage state that is global to the
 * application.
 */
import React, { createContext, useContext, useMemo, useState, useRef } from 'react';
import { useEffect } from 'react';

const EDPContext = createContext();
const SelectedSearchContext = createContext();
const HeaderProfileContext = createContext();

const PermitMWQContext = createContext();
const PermitCumulativeContext = createContext();
const EDPAirQualityContext = createContext();

export const EDPProvider = ({ children }) => {
  const [navClass, setNavClass] = useState('');
  const [aoiSummaryFullData, setAOISummaryFullData] = useState(false);
  const [permitGeometry, setPermitGeometry] = useState(null);
  const [AQStationsInfo, setAQStationsInfo] = useState([]);
  const [stationAQLiveData, setStationAQLiveData] = useState(null);
  const [activeButton, setActiveTaxButton] = useState("Mammals");
  const [buoyDataQCAction, setBuoyDataQCAction] = useState("update");
  const [selectedSearchType, setselectedSearchType] = useState(undefined);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const currentYear = new Date().getFullYear();
  const [geoJsonData, setGeoJsonData] = useState([]);
  const [forecastingFilters, setForecastingFilters] = useState([]);
  const [isHeaderProfileDropdownOpen, setIsHeaderProfileDropdownOpen] = useState(false);
  const [activeTableTabInsect, setActiveTableTabInsect] = useState("edbIns1");
  const [aqEDBFilters, setAQEDBFilters] = useState([]);
  const [aqEDDFilters, setAQEDDFilters] = useState([]);
  const [selectedpanels, setSelectedPanels] = useState({});
  const [rows, setRows] = useState([]);
  const [salinityRow, setSalinityRows] = useState([]);
  const [turtelDataRow, setTurtleDatarow] = useState([]);
  const [DolphinDataRow, setDolphinDataRow] = useState([]);
  const [DugongDataRow, setDugongDataRow] = useState([]);
  const [Selectedoption, setSelectedoption] = useState({ value: 'Turtle', label: 'Turtle' })
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [featurePopupContent, setFeaturePopupContent] = useState("");
  const [selectedLayer, setSelectedLayer] = useState({ value: 'Habitat', label: 'Habitat' });
  const [ForestDatarow, setForestDatarow] = useState([]);
  const [AvianDataRow, setAvianDataRow] = useState([]);
  const [ProtectedDataRow, setProtectedDataRow] = useState([]);
  const [MPADataRow, setMPADataRow] = useState([]);
  const [unit, setUnit] = useState("meters");
  const [distance, setDistance] = useState("100");
  const [MWQunit, setMWQunit] = useState("meters");
  const [MWQdistance, setMWQdistance] = useState("100");
  const [Tunit, setTUnit] = useState("meters");
  const [Tdistance, setTDistance] = useState("100");

  const [Gdistance, setGDistance] = useState("100");
  const [Gunit, setGUnit] = useState("meters");

  const [Sunit, setSUnit] = useState("meters");
  const [Sdistance, setSDistance] = useState("100");
  const [popupLoading, setPopupLoading] = useState(false);

  const [Hdistance, setHDistance] = useState("100");
  const [Hunit, setHUnit] = useState("meters");
  const [SelectedLayeroption, setSelectedLayeroption] = useState({ value: 'Protected Area', label: 'Protected Area' })
  const dataSearchRef = useRef(null);
  const isSidebarDisabled = useRef(false)
  const prevGroundDGeometryRef = useRef(null);
  const prevHabitatGeometryRef = useRef(null);
  const prevTerrsetrialGeometryRef = useRef(null);
  const prevMerineGeometryRef = useRef(null);
  const prevProtedctareaGeometryRef = useRef(null);
  const [InsectsLayer, setInsectsLayer] = useState(false);
  const [PlantsLayer, setPlantsLayer] = useState(false);
  const [ReptilesLayer, setReptilesLayer] = useState(false);
  const [MAmmalsLayer, setMAmmalsLayer] = useState(true);
  const [birdsLayer, setbirdsLayer] = useState(false);
  const [BirdsDistData, setBirdsDistData] = useState({});
  const [Birdsscnt, setBirdsscnt] = useState({});
  const [BirdsHabitatlist, setBirdsHabitatlist] = useState({});
  const prevGeometryRef = useRef(null);
  const [searchlayers, setSearchlayers] = useState([]);
  const SelectedLayersFeaturesDetailsRef = useRef([]);
  const [GroundWatersalinityRows, setGroundWatersalinityRows] = useState([]);
  const [DepletedDataRows, setDepletedDataRows] = useState([]);
  const [GroundWaterWellRows, setGroundWaterWellRows] = useState([]);
  const [GroundWaterlevelRows, setGroundWaterlevelRows] = useState([]);
  const [HabitatRows, setHabitatRows] = React.useState([]);
  const [SensitiveHabitatRows, setSensitiveHabitatRows] = React.useState([]);
  const [criticalHabitatRows, setCriticalHabitatRows] = React.useState([]);
  const [mammalsDistData, setmammalsDistData] = useState({});
  const [mammalscnt, setmammalscnt] = useState({});
  const [mammalsHabitatlist, setmammalsHabitatlist] = useState({});
  const [Habitatmap, setHabitatmap] = useState(true);
  const [criticalHabitat, setCriticalHabitat] = useState(false);
  const [sensitiveHabitat, setSensitiveHabitat] = useState(false);
  const [plantsDistData, setplantsDistData] = useState({});
  const [plantscnt, setplantscnt] = useState({});
  const [plantsHabitatlist, setplantsHabitatlist] = useState({});
  const [selectedArea, setSelectedArea] = useState(null);
  const [reptilesDistData, setreptilesDistData] = useState({});
  const [reptilescnt, setreptilescnt] = useState({});
  const [reptilesHabitatlist, setreptilesHabitatlist] = useState({});
  const [ecologyActiveTab, setEcologyActiveTab] = useState('Terrestrial Biodiversity');
  const [IncectDistData, setIncectDistData] = useState({});
  const [identifyNavTool, setIdentifyNavTool] = useState(false);
  const [printWidget, setPrintWidget] = useState(null);
  //const [mapViewRef, setMapViewRef] = useState(null);
  const [Incectcnt, setIncectcnt] = useState({});
  const [IncectHabitatlist, setIncectHabitatlist] = useState({});
  const [MapHomeButton, setMapHomeButton] = useState(null);
  const [ProtectedAreaUnit, setProtectAreaunit] = useState("meters");
  const [ProtectAreadistance, setProtectAreadistance] = useState("100")
  const [isWebView, setIsWebView] = useState(false);
  //Added for centralizied data access for all the modules(shubham)
  const [globalData, setGlobalData] = useState([
    {
      moduleName: "AirQuality",
      subTabs: [
        {
          name: "LiveData",
          filters: {},
          data: [],
        },
        {
          name: "Forecasting",
          filters: {},
          data: []
        },
        {
          name: "InteractiveAnalysis",
          filters: {},
          prevFilters: {},
          Filter: {},
          filtersToUpdate: [],
          data: [],
          regionData: [],
          locationData: [],
        }
      ],
    },
    {
      moduleName: "MWQ",
      subTabs: [
        {
          name: "MWQIndices",
          filters: {},
          siteList: [],
          prevFilters: {},
          data: [],
        },
        {
          name: "BuoysLiveData",
          filters: {},
          prevFilters: {},
          data: [],
          buoyefficiencyData: [],
          buoyscaptureRateData: [],
          buoystationinfo: []
        },
        {
          name: "BuoysCaptureData",
          filters: {},
          prevFilters: {},
          data: [],
        },
        {
          name: "BuoysAnalytics",
          filters: {},
          prevFilters: {},
          data: [],
          anomaliesData: [],
          exceedanceValuesData: []
        },
        {
          name: "MWQAnalytics",
          filters: {},
          prevFilters: {},
          data: [],
        },
        {
          name: "Incidents",
          filters: {},
          prevFilters: {},
          data: [],
        },
        {
          name: "DownloadData",
          filters: {},
          prevFilters: {},
          data: [],
        }
      ]
    },
    {
      moduleName: "Animal Sighting",
      subTabs: [
        {
          name: "PendingRecords",
          filters: {},
          prevFilters: {},
          data: [],
        },
        {
          name: "ApprovedRecords",
          filters: {},
          prevFilters: {},
          data: [],
        },
      ]
    },
    {
      moduleName: "Header",
      data: [],
      subTabs: []
    }

  ]);
  const [nativeAppAPIState, setNativeAppAPIState] = useState(undefined);

  /**state variables to retain selection (grouped module wise)*/
  const [aqHDSettings, setAQHDSettings] = useState({
    station: 6,
    duration: '1 Hr',
    year: [currentYear - 5, currentYear]
  });

  const [aqLDSettings, setAQLDSettings] = useState({
    // station: 'Hamdan Street',
    station: 'Al Ain Islamic Institute',
    date: null,
  });

  const updateAQHDSettings = (key, value) => {
    setAQHDSettings((prev) => ({ ...prev, [key]: value }));
  };

  const updateAQLDSettings = (key, value) => {
    setAQLDSettings((prev) => ({ ...prev, [key]: value }));
  };
  const selectedSearchContextValue = useMemo(() => ({
    selectedSearchType, setselectedSearchType, isCollapsed, setIsCollapsed, dataSearchRef, searchlayers, setSearchlayers, printWidget, setPrintWidget,
  }), [selectedSearchType, isCollapsed, searchlayers, printWidget]);

  // const aqEDBContextValue = useMemo(() => ({
  //   aqEDBFilters, setAQEDBFilters, aqEDDFilters, setAQEDDFilters
  // }), [aqEDBFilters, aqEDDFilters]);

  //this function will reset the  persistent values when we close the permit module
  const resetMWQData = () => {
    setAQStationsInfo([]);
    setSelectedPanels({});
    setAQChartOptions({
      EDB: null,
      EDD: null,
      EDBvsEDD: null,
      NoData: false
    });
    setAQEDBFilters([]);
  };
  const resetHomeButton = () => {
    MapHomeButton?.go();
  };


  // this function will reset the persistent values when we close animal sighting or mwq module
  const resetMWQModuleData = () => {
    setGlobalData(prevData =>
      prevData.map(module =>
        (module.moduleName === "MWQ" || module.moduleName === "Animal Sighting")
          ? {
            ...module,
            ...(module.moduleName === "MWQ" && {
              activetab: null,
              selectedMWQOption: null,
              activeComponent: null
            }),
            ...(module.moduleName === "Animal Sighting" && {
              activeTab: null,
            }),
            subTabs: module.subTabs.map(subTab => ({
              ...subTab,
              filters: {}, // Reset filters
              prevFilters: {}, // Reset prevFilters
              data: [], // Reset data

              //  Reset only if the key exists
              ...(subTab.activePendingtabs && { activePendingtabs: null }), // Reset activeApprovedtabs if available
              ...(subTab.activeApprovedtabs && { activeApprovedtabs: null }), // Reset activeApprovedtabs if available
              ...(subTab.selectedRows && { selectedRows: {} }), // Reset selectedRows
              ...(subTab.siteList && { siteList: [] }), // Reset siteList if available
              ...(subTab.buoyefficiencyData && { buoyefficiencyData: [] }), // Reset buoy efficiency
              ...(subTab.buoyscaptureRateData && { buoyscaptureRateData: [] }), // Reset capture rate
              ...(subTab.buoystationinfo && { buoystationinfo: [] }), // Reset station info
              ...(subTab.anomaliesData && { anomaliesData: [] }), // Reset anomalies data
              ...(subTab.exceedanceValuesData && { exceedanceValuesData: [] }) // Reset exceedance data
            }))
          }
          : module // Keep other modules unchanged
      )
    );
  };
  const resetAirQualityModuleData = () => {
    setAQLDSettings({
      // station: 'Hamdan Street',
      station: 'Al Ain Islamic Institute',
      date: null,
    });

    setAQHDSettings({
      station: 6,
      duration: '1 Hr',
      year: [currentYear - 5, currentYear]
    });

    setGlobalData((prev) =>
      prev.map((module) =>
        module.moduleName === "AirQuality"
          ? {
            ...module,
            activeComponentLabel: null,
            activeComponentValue: null,
            subTabs: module.subTabs.map((subTab) =>
              subTab.name === "InteractiveAnalysis"
                ? {
                  ...subTab,
                  filters: {},
                  prevFilters: {},
                  Filter: {},
                  filtersToUpdate: [],
                  data: [],
                  regionData: [],
                  locationData: [],
                }
                : subTab
            ),
          }
          : module
      )
    );
    setGeoJsonData([]);
    setForecastingFilters([]);
  }
  const headerProfileContextValue = useMemo(() => ({
    isHeaderProfileDropdownOpen, setIsHeaderProfileDropdownOpen, resetMWQData, resetAirQualityModuleData, isSidebarDisabled, MapHomeButton, setMapHomeButton, resetHomeButton, resetMWQModuleData
  }), [isHeaderProfileDropdownOpen, MapHomeButton]);

  /**permit MWQ states */
  const [permitData, setPermitData] = useState(null);
  const [permitFilters, setPermitFilters] = useState({
    edb: {},
    edd: {},
    eddvsedb: {},
  });
  const [isPermitApproved, setIsPermitApproved] = useState(false);
  const [perMWQApiRes, setPerMWQApiRes] = useState({
    edb: {
      filterOptionsData: null,
      sitesParamsData: null,
      sitesIndicesData: null
    }
  });

  const [mwqChartOptions, setMWQChartOptions] = useState({
    indices: {
      edb: null,
      edd: null,
      edbVsEdd: null
    },
    params: {
      edb: null,
      edd: null,
      edbVsEdd: null
    }
  });

  const [AQChartOptions, setAQChartOptions] = useState({
    EDB: null,
    EDD: null,
    EDBvsEDD: null,
    NoData: false
  });
  const globalDataContextValue = useMemo(() => ({
    globalData, setGlobalData
  }), [globalData]);
  const NativeAppContextValue = useMemo(() => ({
    nativeAppAPIState, setNativeAppAPIState
  }), [nativeAppAPIState]);
  const permitContextValue = useMemo(() => ({
    permitData, setPermitData,
    permitFilters, setPermitFilters,
    isPermitApproved, setIsPermitApproved,
    perMWQApiRes, setPerMWQApiRes,
    mwqChartOptions, setMWQChartOptions,
    AQChartOptions, setAQChartOptions,
    // Add reset function
  }), [permitData, permitFilters, isPermitApproved, perMWQApiRes, mwqChartOptions, AQChartOptions]);


  const [cumulativeData, setCumulativeData] = useState({
    activeCategory: "AirQualityCumulative",
    activeParameter: null
  });
  const permitCumulativeValue = useMemo(() => ({
    cumulativeData, setCumulativeData
  }), [cumulativeData]);


  return (
    <EDPContext.Provider value={{
      navClass, setNavClass,
      aoiSummaryFullData, setAOISummaryFullData,
      AQStationsInfo, setAQStationsInfo, stationAQLiveData, setStationAQLiveData,
      aqHDSettings, updateAQHDSettings, setAQHDSettings, aqLDSettings, updateAQLDSettings, setAQLDSettings,
      buoyDataQCAction, setBuoyDataQCAction, selectedSearchType, setselectedSearchType,
      geoJsonData, setGeoJsonData, forecastingFilters, setForecastingFilters, isWebView, setIsWebView,
      setAQEDBFilters, setAQEDDFilters, aqEDBFilters, aqEDDFilters, selectedpanels, setSelectedPanels,
      SelectedLayeroption, setSelectedLayeroption, setForestDatarow, ForestDatarow, setAvianDataRow, AvianDataRow, setProtectedDataRow, setMPADataRow, MPADataRow, ProtectedDataRow,
      globalDataContextValue, NativeAppContextValue, permitContextValue,
      permitGeometry, setPermitGeometry,
      Tunit, setTUnit,
      Tdistance, setTDistance,
      prevMerineGeometryRef, isPopupVisible, setIsPopupVisible,
      featurePopupContent, setFeaturePopupContent,
      Hdistance, setHDistance,
      Hunit, setHUnit,
      MWQunit, setMWQunit, MWQdistance, setMWQdistance,
      Gunit, setGUnit,
      Gdistance, setGDistance,
      prevProtedctareaGeometryRef,
      Sdistance, setSDistance,
      Sunit, setSUnit,
      popupLoading, setPopupLoading,
      unit, setUnit,
      distance, setDistance,
      selectedArea, setSelectedArea,
      activeButton, setActiveTaxButton,
      activeTableTabInsect, setActiveTableTabInsect,
      InsectsLayer, setInsectsLayer,
      PlantsLayer, setPlantsLayer,
      ReptilesLayer, setReptilesLayer,
      MAmmalsLayer, setMAmmalsLayer,
      birdsLayer, setbirdsLayer,
      BirdsDistData, setBirdsDistData,
      Birdsscnt, setBirdsscnt,
      BirdsHabitatlist, setBirdsHabitatlist,
      SelectedLayersFeaturesDetailsRef,
      prevGeometryRef,
      salinityRow, setSalinityRows,
      ProtectedAreaUnit, setProtectAreaunit, ProtectAreadistance, setProtectAreadistance,
      rows, setRows, prevGroundDGeometryRef, prevHabitatGeometryRef, prevTerrsetrialGeometryRef,
      selectedLayer, setSelectedLayer,
      GroundWatersalinityRows, setGroundWatersalinityRows,
      DepletedDataRows, setDepletedDataRows,
      GroundWaterWellRows, setGroundWaterWellRows,
      GroundWaterlevelRows, setGroundWaterlevelRows,
      HabitatRows, setHabitatRows,
      SensitiveHabitatRows, setSensitiveHabitatRows,
      criticalHabitatRows, setCriticalHabitatRows,
      ecologyActiveTab, setEcologyActiveTab,
      Habitatmap, setHabitatmap,

      criticalHabitat, setCriticalHabitat,
      sensitiveHabitat, setSensitiveHabitat,
      mammalsDistData, setmammalsDistData, mammalscnt, setmammalscnt, mammalsHabitatlist, setmammalsHabitatlist,
      plantsDistData, setplantsDistData, plantscnt, setplantscnt, plantsHabitatlist, setplantsHabitatlist,
      reptilesDistData, setreptilesDistData, reptilescnt, setreptilescnt, reptilesHabitatlist, setreptilesHabitatlist,
      IncectDistData, setIncectDistData, Incectcnt, setIncectcnt, IncectHabitatlist, setIncectHabitatlist, identifyNavTool, setIdentifyNavTool,
      Selectedoption, setSelectedoption, DugongDataRow, setDugongDataRow, turtelDataRow, setTurtleDatarow, DolphinDataRow, setDolphinDataRow,
    }}
    >
      <SelectedSearchContext.Provider value={
        selectedSearchContextValue
      }>
        <HeaderProfileContext.Provider value={headerProfileContextValue}>
          <PermitMWQContext.Provider value={permitContextValue}>
            <PermitCumulativeContext.Provider value={permitCumulativeValue}>
              {children}
            </PermitCumulativeContext.Provider>
          </PermitMWQContext.Provider>
        </HeaderProfileContext.Provider>
      </SelectedSearchContext.Provider>

    </EDPContext.Provider>
  );
};

export const useEDPContext = () => useContext(EDPContext);
export const useSelectedSearchContext = () => useContext(SelectedSearchContext);
export const useHeaderProfileContext = () => useContext(HeaderProfileContext);

export const usePermitMWQContext = () => useContext(PermitMWQContext);
export const useEDPAirQualityContext = () => useContext(EDPAirQualityContext)
export const usePermitCumulativeContext = () => useContext(PermitCumulativeContext);